(() => {
  const selector = '.jdgm-widget.jdgm-cards-carousel';
  const interval = 3500;

  function moveJapaneseReviewLast(root) {
    const cards = [...root.querySelectorAll('.jdgm-carousel-item')];
    const originals = cards.filter(card => !card.dataset.cloneType);
    if (originals.length < 2) return;

    const containsJapanese = value => /[\u3040-\u30ff\u3400-\u9fff]/.test(value || '');
    const japaneseCard = originals.find(card =>
      containsJapanese(card.querySelector('.jdgm-text')?.textContent)
    );
    const lastCard = originals[originals.length - 1];

    if (!japaneseCard || japaneseCard === lastCard) return;

    const japaneseIndex = japaneseCard.dataset.cardIndex;
    const lastIndex = lastCard.dataset.cardIndex;
    const japaneseContent = {
      html: japaneseCard.innerHTML,
      reviewId: japaneseCard.dataset.reviewId
    };
    const lastContent = {
      html: lastCard.innerHTML,
      reviewId: lastCard.dataset.reviewId
    };

    cards.forEach(card => {
      if (card.dataset.cardIndex === japaneseIndex) {
        card.innerHTML = lastContent.html;
        card.dataset.reviewId = lastContent.reviewId;
      } else if (card.dataset.cardIndex === lastIndex) {
        card.innerHTML = japaneseContent.html;
        card.dataset.reviewId = japaneseContent.reviewId;
      }
    });
  }

  function start(root) {
    if (root.dataset.druzelAutoplayReady === 'true') return;
    const next = root.querySelector('button[aria-label="Next slide"]');
    if (!next) return;

    let timer;
    let paused = false;
    let visible = true;

    const stop = () => window.clearTimeout(timer);
    const schedule = () => {
      stop();
      if (paused || !visible || document.hidden) return;
      timer = window.setTimeout(() => {
        if (!paused && visible && !document.hidden) next.click();
        schedule();
      }, interval);
    };

    root.addEventListener('mouseenter', () => {
      paused = true;
      stop();
    });
    root.addEventListener('mouseleave', () => {
      paused = false;
      schedule();
    });
    root.addEventListener('focusin', () => {
      paused = true;
      stop();
    });
    root.addEventListener('focusout', () => {
      paused = false;
      schedule();
    });
    root.addEventListener('pointerdown', () => {
      paused = true;
      stop();
    });
    root.addEventListener('pointerup', () => {
      window.setTimeout(() => {
        paused = false;
        schedule();
      }, 900);
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting;
        if (visible) schedule();
        else stop();
      }, { threshold: 0.25 });
      observer.observe(root);
    }

    document.addEventListener('visibilitychange', schedule);
    root.dataset.druzelAutoplayReady = 'true';

    schedule();
  }

  function boot() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll(selector).forEach(root => {
      moveJapaneseReviewLast(root);
      start(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  new MutationObserver(boot).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
